import types, { IAction } from '../../types/actions';

export enum UnitEnum {
	KG = 'kg',
	KS = 'ks',
}

export interface IProductState {
	fetchProduct: string;
	product?: IProduct;
}

export interface IProduct {
	allergens: string;
	barCode: string;
	code: string;
	composition: string;
	description: string;
	diet: string;
	image: string;
	name: string;
	nutritionalValues: string;
	price?: number;
	storeAt: string;
	unit: UnitEnum;
}

export const initialState: IProductState = {
	fetchProduct: '',
	product: undefined,
};

export const productReducer = (state = initialState, action: IAction) => {
	switch (action.type) {
		case types.PRODUCT_DETAIL_FETCH_SUCCESS: {
			return {
				...state,
				product: action.payload,
			};
		}
		case types.PRODUCT_DETAIL_FETCH_FAILURE: {
			return {
				...state,
			};
		}
		case types.PRODUCT_DETAIL_RESET: {
			return {
				...state,
				product: undefined,
			};
		}
		default:
			return state;
	}
};
